import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  useLocation,
  useNavigate
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import i18next from 'i18next'
import ModalProvider from 'mui-modal-provider'
import { allRoutes } from './routes/Routes'
import { useAppSelector } from './app/hooks'
import { isDarkTheme } from './redux/features/theme/themeSlice'
import { ThemeProvider } from '@emotion/react'
import { darkTheme, lightTheme } from './theme'
import { useIdleTimer } from './hooks'
import { useEffect } from 'react'
import { PATH_NAME } from './constants'
import { selectAuth } from './redux/features'

function ProviderLayersOutlet() {
  useIdleTimer(
    process.env.REACT_APP_IDLE_TIMER_MS
      ? parseInt(process.env.REACT_APP_IDLE_TIMER_MS)
      : undefined
  )
  const isDarkMode = useAppSelector(isDarkTheme)
  i18next.on('languageChanged', lng => {
    document.documentElement.setAttribute('lang', lng)
  })
  const location = useLocation()
  const navigate = useNavigate()
  const user = useAppSelector(selectAuth)

  // Check if password is expired
  useEffect(() => {
    if (
      user.errorCode === 1 &&
      location.pathname !== PATH_NAME.PROFILE_SETTING.path &&
      location.pathname !== PATH_NAME.SETTINGS.path
    ) {
      navigate(PATH_NAME.PROFILE_SETTING.path)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, user.errorCode])

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <ModalProvider>
        <ToastContainer
          className='toast-container'
          hideProgressBar
          autoClose={3000}
        />
        <div className='App'>
          <Outlet />
        </div>
      </ModalProvider>
    </ThemeProvider>
  )
}

const router = createBrowserRouter([
  {
    element: <ProviderLayersOutlet />,
    children: [...allRoutes]
  }
])

export default function App() {
  return <RouterProvider router={router} />
}
